module.exports = __webpack_public_path__ + "img/calculator.4d57a30a.png";